import React, { Component } from "react";
import { toast } from "react-toastify";

import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
  Card,
  CardContent,
  CircularProgress,
  InputAdornment,
  IconButton,
  Chip
} from "@mui/material";

import FileOpenIcon from "@mui/icons-material/FileOpen";
import SaveIcon from "@mui/icons-material/Save";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { apiUrl } from "../../../comps/apiUrl";
import withLocation from "../../../comps/withLocation";

class SelectStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      error: false,
      showPassword: false,
      data: {
        id: "",
        name: "",
        razao_social: "",
        token: "",
        address: "",
        city: "",
        cnpj: "",
        email: "",
        mobile: "",
        neighborhood: "",
        phone: "",
        state: "",
        inscricao_estadual: "",
        regime_tributario: "1",
        nfe_serie: "1",
        nfe_proximo_numero: "1",
        nfe_ambiente: "2",
        certificado_senha: "",
        has_certificado: false
      },
      certificado_arquivo: null,
      nome_arquivo_selecionado: ""
    };
  }

  componentDidMount() {
    document.title = "Carregando...";
    this.carregarDadosLoja();
  }

  carregarDadosLoja = () => {
    fetch(`${apiUrl}/store/select/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status === 404) {
          this.setState({ loader: false });
          toast.error("Loja não encontrada.");
        }

        if (response.status === 200) {
          response.json().then((data) => {
            document.title = data.name;
            this.setState({
              data: {
                ...this.state.data,
                ...data,
                address: data.address || "",
                city: data.city || "",
                email: data.email || "",
                mobile: data.mobile || "",
                neighborhood: data.neighborhood || "",
                phone: data.phone || "",
                state: data.state || "",
                razao_social: data.razao_social || "",
                regime_tributario: data.regime_tributario || "1",
                nfe_serie: data.nfe_serie || "1",
                nfe_proximo_numero: data.nfe_proximo_numero || "1",
                nfe_ambiente: data.nfe_ambiente || "2",
                certificado_senha: data.certificado_senha || "",
                has_certificado: !!data.certificado
              },
              loader: false,
            });
          });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
        toast.error("Ocorreu um erro ao carregar as configurações da loja");
      });
  };

  handleInputChange = (e) => {
    const { id, name, value } = e.target;
    const targetName = id || name;
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [targetName]: value
      }
    }));
  };

  handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      this.setState({
        certificado_arquivo: e.target.files[0],
        nome_arquivo_selecionado: e.target.files[0].name
      });
    }
  };

  toggleShowPassword = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleSalvarDadosFiscais = (e) => {
    e.preventDefault();
    const { data, certificado_arquivo } = this.state;

    if (!data.inscricao_estadual) return toast.warning("A Inscrição Estadual é obrigatória!");
    if (!data.nfe_proximo_numero) return toast.warning("Informe o próximo número de nota!");

    if (certificado_arquivo && !data.certificado_senha) {
      return toast.warning("Informe a senha para validar o novo arquivo de certificado!");
    }

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      // Ignora chaves auxiliares ou que não devem ser tratadas como texto comum no formData
      if (key !== "has_certificado" && key !== "certificado") {
        formData.append(key, data[key] ?? "");
      }
    });

    if (certificado_arquivo) {
      formData.append("certificado", certificado_arquivo);
    }

    fetch(`${apiUrl}/store/update-fiscal-config`, {
      method: "POST",
      headers: {
        authorization: localStorage.getItem("token")
      },
      body: formData
    })
      .then(async (res) => {
        if (res.status === 200) {
          toast.success("Dados salvos com sucesso!");
          this.carregarDadosLoja();
        } else {
          const respostaErro = await res.json();
          toast.error(respostaErro.error || "Erro ao salvar dados fiscais.");
        }
      })
      .catch(() => toast.error("Falha na comunicação com o servidor."));
  };

  render() {
    if (this.state.loader) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
          <CircularProgress size={60} thickness={4} />
        </Box>
      );
    }

    const { data, showPassword, nome_arquivo_selecionado } = this.state;

    return (
      <Box sx={{ p: { xs: 2, md: 4 }, margin: "0 auto", maxWidth: 1000 }}>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12}>
            <Card variant="outlined" sx={{ borderRadius: 3, borderColor: "#e2e8f0" }}>
              <Box sx={{ p: 2, bgcolor: "#1976d2", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <FileOpenIcon />
                  <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                    Parâmetros Fiscais e Cadastrais
                  </Typography>
                </Box>
              </Box>

              <form onSubmit={this.handleSalvarDadosFiscais}>
                <CardContent sx={{ p: 3 }}>

                  {/* Seção 1: Identificação */}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#344767", mb: 2 }}>
                    1. Dados Cadastrais da Empresa
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item size={{ xs: 6 }}>
                      <TextField fullWidth label="Nome da Loja" id="name" value={data.name || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item size={{ xs: 6 }}>
                      <TextField fullWidth label="Razão Social" id="razao_social" value={data.razao_social || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6}>
                      <TextField fullWidth label="CNPJ" value={data.cnpj || ""} id="cnpj" onChange={this.handleInputChange} size="small" variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Inscrição Estadual (IE)"
                        id="inscricao_estadual"
                        placeholder="Apenas números"
                        value={data.inscricao_estadual || ""}
                        onChange={this.handleInputChange}
                        size="small"
                        required
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 3 }} />

                  {/* Seção 2: Contato e Endereço */}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#344767", mb: 2 }}>
                    2. Contato e Localização
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item size={{ xs: 5 }}>
                      <TextField fullWidth label="E-mail" id="email" type="email" value={data.email || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField fullWidth label="Telefone" id="phone" value={data.phone || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField fullWidth label="Celular / WhatsApp" id="mobile" value={data.mobile || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item size={{ xs: 2 }}>
                      <TextField fullWidth label="Cep" id="zip_code" value={data.zip_code || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item size={{ xs: 2 }}>
                      <TextField fullWidth label="Código Município" id="code_municipio" value={data.code_municipio || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item size={{ xs: 5 }}>
                      <TextField fullWidth label="Endereço" id="address" value={data.address || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item size={{ xs: 2 }}>
                      <TextField fullWidth label="Número" id="number" value={data.number || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField fullWidth label="Bairro" id="neighborhood" value={data.neighborhood || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <TextField fullWidth label="Cidade" id="city" value={data.city || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                    <Grid item xs={12} sm={1}>
                      <TextField fullWidth label="UF" id="state" value={data.state || ""} size="small" onChange={this.handleInputChange} variant="outlined" />
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 3 }} />

                  {/* Seção 3: Certificado Digital */}
                  <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#344767" }}>
                      3. Certificado Digital A1
                    </Typography>
                    {data.has_certificado && !nome_arquivo_selecionado && (
                      <Chip icon={<CheckCircleIcon />} label="Certificado Ativo no Servidor" color="success" variant="outlined" size="small" />
                    )}
                  </Box>

                  <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<UploadFileIcon />}
                          color={nome_arquivo_selecionado ? "success" : "primary"}
                          size="medium"
                          fullWidth
                          sx={{ height: "40px", textTransform: "none" }}
                        >
                          {data.has_certificado ? "Substituir Certificado Atual (.pfx)" : "Selecionar Certificado (.pfx)"}
                          <input type="file" hidden accept=".pfx,.p12" onChange={this.handleFileChange} />
                        </Button>
                        <Typography variant="caption" color={nome_arquivo_selecionado ? "success.main" : "text.secondary"} sx={{ pl: 0.5 }}>
                          {nome_arquivo_selecionado ? `Arquivo preparado: ${nome_arquivo_selecionado}` : "Deixe em branco para manter o certificado atual guardado no sistema."}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Senha do Certificado"
                        id="certificado_senha"
                        type={showPassword ? "text" : "password"}
                        placeholder="Senha de importação"
                        value={data.certificado_senha || ""}
                        onChange={this.handleInputChange}
                        size="small"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={this.toggleShowPassword} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 3 }} />

                  {/* Seção 4: Numeração e Ambiente */}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#344767", mb: 2 }}>
                    4. Sequenciamento e Configuração do Emissor
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        select
                        label="Ambiente de Emissão"
                        name="nfe_ambiente"
                        value={data.nfe_ambiente}
                        onChange={this.handleInputChange}
                        size="small"
                      >
                        <MenuItem value="2">2 - Homologação (Testes)</MenuItem>
                        <MenuItem value="1">1 - Produção (Valor Fiscal)</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Série da NF-e"
                        id="nfe_serie"
                        type="number"
                        value={data.nfe_serie}
                        onChange={this.handleInputChange}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Próximo Número da NF-e"
                        id="nfe_proximo_numero"
                        type="number"
                        value={data.nfe_proximo_numero}
                        onChange={this.handleInputChange}
                        size="small"
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        select
                        label="Regime Tributário da Loja"
                        name="regime_tributario"
                        value={data.regime_tributario}
                        onChange={this.handleInputChange}
                        size="small"
                      >
                        <MenuItem value="1">1 - Simples Nacional</MenuItem>
                        <MenuItem value="3">3 - Regime Normal (Lucro Presumido/Real)</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>

                </CardContent>

                <Box sx={{ p: 2, bgcolor: "#f8fafc", display: "flex", justifyContent: "flex-end", borderTop: "1px solid #e2e8f0" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    sx={{ px: 4, fontWeight: "bold" }}
                    disableElevation
                  >
                    Salvar Parâmetros Fiscais
                  </Button>
                </Box>
              </form>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withLocation(SelectStore);